export default {
  name: 'Sword Health',
  logo: 'login/sword/logo-primary.svg',
  logoMobile: 'login/sword/logo-primary-mobile.svg',
  loginImage: 'login/sword/login-image.png',
};
